import {
    Box,
    Button,
    FormControl,
    FormLabel,
    Heading,
    HStack,
    Input, Spinner,
    Table,
    Tbody, Td,
    Th,
    Thead,
    Tr, useToast
} from "@chakra-ui/react";
import React, {useEffect, useState} from "react";
import dayjs from "dayjs";
import {PITrigger} from "../../api/triggerAPI";
import {api} from "../../api/triggerAPI";

export const PerformanceIncentiveTriggers: React.FC = () => {
  const [triggers, setTriggers] = useState<PITrigger[]>([]);
  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(true);
  const toast = useToast();

  const [refreshIndex, setRefreshIndex] = useState(0);
  useEffect(() => {
      api.getAllTriggers()
          .then((res) => {
              const sortedTriggers = res.data.sort((a, b) => {
                  return new Date(a.generation_time).getTime() - new Date(b.generation_time).getTime()
              })

              setTriggers(sortedTriggers)
          })
          .catch(() =>
              toast({
                  title: "Error loading triggers.",
                  status: "error",
                  duration: 3000,
                  isClosable: true,
              })
          )
          .finally(() => setLoading(false));
  }
  ,[refreshIndex]);

  const addNewTrigger = async () => {
    if (!startDate || !endDate) return;

    const generation_time =  dayjs(startDate).format("YYYY-MM-DDTHH:mm:ss"); // e.g. "2025-05-01T10:30:00"
    const completionTime =  dayjs(endDate).format("YYYY-MM-DDTHH:mm:ss"); // e.g. "2025-05-01T10:30:00"

    const newTrigger: Partial<PITrigger> = {
        generation_time: generation_time,
        completion_time: completionTime

    };

    try {
       const response =   await api.addTrigger(newTrigger)
      setStartDate("")
      setEndDate("")
    setRefreshIndex(prevState => prevState+1)
      toast({
        title: "Trigger added.",
        status: "success",
        duration: 2000,
        isClosable: true,
      });
    } catch (error) {
      toast({
        title: "Error adding trigger.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const deleteTrigger = async (task_id: string) => {
    try {
      await api.deleteTrigger(task_id)

      toast({
        title: "Trigger deleted.",
        status: "info",
        duration: 2000,
        isClosable: true,
      });
    } catch {
      toast({
        title: "Failed to delete trigger.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
    setRefreshIndex(prevState => prevState+1)
  };

  if (loading) {
    return <Spinner size="lg" />;
  }
  const getStatus =  (trigger: PITrigger) :string=> {
      if (dayjs().isAfter(dayjs(trigger.completion_time)))return "Completed"
      if (dayjs().isAfter(dayjs(trigger.generation_time))) return "In Progress"
      return "Not Executed"
    }
  return (
    <>
      <Box mt={5} borderWidth={1} borderRadius="md" p={3} shadow="sm" width="sm" flexGrow={1}>
        <Heading size="sm" mb={3}>
          Performance Incentive Dates
        </Heading>
        <FormControl>
          <FormLabel>New Date</FormLabel>
          <HStack>
    <Input
      type="datetime-local"
      value={startDate}
      onChange={(e) => setStartDate(e.target.value)}
      placeholder="Start Date"
    />
    <Input
      type="datetime-local"
      value={endDate}
      onChange={(e) => setEndDate(e.target.value)}
      placeholder="End Date"
    />
            <Button colorScheme="teal" onClick={event =>addNewTrigger()}>
              Add
            </Button>
          </HStack>
        </FormControl>
        <Table mt={3} variant="striped" size="sm">
          <Thead>
            <Tr>
                <Th>Task Id</Th>
         <Th>Month</Th>
              <Th>Generation Time</Th>
              <Th>Completion Time</Th>
              <Th>Status</Th>
              <Th>Actions</Th>
            </Tr>
          </Thead>
          <Tbody>
            {triggers.map((trigger) => (
              <Tr key={trigger.cloud_task_job_id_generation}>
                 <Td>{trigger.cloud_task_job_id_generation}</Td>
<Td>{dayjs(trigger.generation_time).format("MMMM, YYYY")}</Td>
                <Td>{dayjs(trigger.generation_time).format("YYYY-MM-DD HH:mm")}</Td>
                          <Td>{dayjs(trigger.completion_time).format("YYYY-MM-DD HH:mm")}</Td>
                <Td>
                  {getStatus(trigger)}
                </Td>
                <Td>
                  {getStatus(trigger)=== "Not Executed" && (
                    <Button
                      size="xs"
                      colorScheme="red"
                      onClick={() =>
                        deleteTrigger(trigger.cloud_task_job_id_generation)
                      }
                    >
                      Remove
                    </Button>
                  )}
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>
    </>
  );
};